function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

function positionPictures(pic1, pic2, pic3) {

    pos1 = [33, 33]
    pos2 = [66, 33]
    pos3 = [50, 66]

    // Apply style with a random offset for each picture, wait a delay before going to the next one

    const randomOffset = 50

    pic1.style.left = `calc(${pos1[0]}% + ${getRandomInt(-randomOffset, randomOffset)}px)`;
    pic1.style.top = `calc(${pos1[1]}% + ${getRandomInt(-randomOffset, randomOffset)}px)`;

    pic2.style.left = `calc(${pos2[0]}% + ${getRandomInt(-randomOffset, randomOffset)}px)`;
    pic2.style.top = `calc(${pos2[1]}% + ${getRandomInt(-randomOffset, randomOffset)}px)`;

    pic3.style.left = `calc(${pos3[0]}% + ${getRandomInt(-randomOffset, randomOffset)}px)`;
    pic3.style.top = `calc(${pos3[1]}% + ${getRandomInt(-randomOffset, randomOffset)}px)`;
}

async function resetTheMess(messy_pictures, pic1, pic2, pic3, closing_text) {

    messy_pictures.classList.remove('active');
    closing_text.classList.remove('active');
    await new Promise(r => setTimeout(r, 75));
    pic1.classList.remove('active');
    await new Promise(r => setTimeout(r, 75));
    pic2.classList.remove('active');
    await new Promise(r => setTimeout(r, 75));
    pic3.classList.remove('active');
    await new Promise(r => setTimeout(r, 300));
    messy_pictures.style.display = 'none';

    pic1.remove();
    pic2.remove();
    pic3.remove();
    closing_text.remove();
  
    messy_pictures.onclick = function() {}; // reset onclick
    window.onkeydown = function() {}; // reset onkeydown
    window.onscroll = function() {}; // reset onscroll
}

async function openTheMess(pic1_img, pic2_img, pic3_img) {

    // Create pics and add them to messy-pictures
    const messy_pictures = document.querySelector('.messy-pictures');
    const pic1 = document.createElement('img');
    pic1.src = pic1_img;
    const pic2 = document.createElement('img');
    pic2.src = pic2_img;
    const pic3 = document.createElement('img');
    pic3.src = pic3_img;
    const closing_text = document.createElement('h4');
    closing_text.textContent = "Appuyez pour fermer";
    messy_pictures.append(pic1, pic2, pic3, closing_text);

    // Display images on the screen
    positionPictures(pic1, pic2, pic3);

    // Active pictures one by one, with a delay between them
    messy_pictures.style.display = 'block';
    await new Promise(r => setTimeout(r, 5));
    messy_pictures.classList.add('active');
    await new Promise(r => setTimeout(r, 10));
    pic1.classList.add('active');
    await new Promise(r => setTimeout(r, 75));
    pic2.classList.add('active');
    await new Promise(r => setTimeout(r, 75));
    pic3.classList.add('active');
    await new Promise(r => setTimeout(r, 300));
    closing_text.classList.add('active');

    // Add onclick event to messy-pictures
    messy_pictures.onclick = () => resetTheMess(messy_pictures, pic1, pic2, pic3, closing_text);
    window.onkeydown = () => resetTheMess(messy_pictures, pic1, pic2, pic3, closing_text);
    window.onscroll = () => resetTheMess(messy_pictures, pic1, pic2, pic3, closing_text);
}

document.addEventListener('DOMContentLoaded', () => {

    // parallax effect
    const messy_pictures = document.querySelector('.messy-pictures');

    messy_pictures.onmousemove = function(e) {
        const images = messy_pictures.querySelectorAll('img');
    
        const rect = messy_pictures.getBoundingClientRect();
        const x = e.clientX - rect.left; // Get the horizontal coordinate inside the container
        const y = e.clientY - rect.top; // Get the vertical coordinate inside the container
    
        images.forEach((img, index) => {
            const movementStrength = -10; // Adjust movement strength as needed
            const offsetX = ((x - rect.width / 2) / rect.width) * movementStrength;
            const offsetY = ((y - rect.height / 2) / rect.height) * movementStrength;
    
            img.style.transform = `translate(${offsetX * (index + 1)}px, ${offsetY * (index + 1)}px)`;
        });
    }
});